import 'owl.carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';

export default function promotionalProductSLider() {
  $('.promotional-product-slider .products-small-wrap').owlCarousel({
    margin: 0,
    stagePadding: 30,
    dots: false,
    items: 3,
    nav: true,
    navContainer: '#pps-nav',
    navText: ['', ''],
    autoWidth: true,
    loop: true,
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 2
      },
      768: {
        items: 3
      }
    }
  });
}
